import type { ReactNode } from 'react';
import { ScreenLink as Link } from '../permissions/ScreenLink';
import { ChevronLeft } from 'lucide-react';

/**
 * Quiet "open the full screen" link. The chevron points forward in the
 * reading direction (left in RTL, mirrored to the right in LTR) — replaces
 * the hard-coded "→" that pointed backwards in Hebrew.
 */
export default function ForwardLink({ to, children, className = '' }: { to: string; children: ReactNode; className?: string }) {
  return (
    <Link
      to={to}
      closed="hide"
      className={`inline-flex items-center gap-0.5 text-sm font-medium text-primary-700 hover:text-primary-800 hover:underline underline-offset-2 whitespace-nowrap rounded-xs ${className}`}
    >
      {children}
      <ChevronLeft size={16} className="flex-shrink-0 ltr:rotate-180" aria-hidden="true" />
    </Link>
  );
}
